"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.oauthFetch = exports.REFRESH_TOKEN_PATH = void 0;
const jwt_decode_1 = __importDefault(require("jwt-decode"));
const universal_cookie_1 = __importDefault(require("universal-cookie"));
const config_1 = require("./config");
const request_1 = require("./request");
const user_storage_1 = __importDefault(require("./user.storage"));
exports.REFRESH_TOKEN_PATH = '/oauth/token';
const cookies = new universal_cookie_1.default();
const oauthFetch = (payload, customHeaders = {}) => {
    const OAUTH_TOKEN_ENDPOINT = `${config_1.AUTH_ENDPOINT}/oauth/token`;
    const OAUTH_CLIENT_ID = '533bf5c8dbd05ef18fd01e2bbbab3d7f69e3511dd08402862b5de63b9a238923';
    return fetch(OAUTH_TOKEN_ENDPOINT, {
        method: 'POST',
        body: JSON.stringify({
            client_id: OAUTH_CLIENT_ID,
            ...payload,
        }),
        headers: (0, request_1.getRequestHeaders)(customHeaders),
    });
};
exports.oauthFetch = oauthFetch;
const JWT_COOKIE_KEY = 'lunchr:jwt';
const REFRESHTOKEN_COOKIE_KEY = 'lunchr:rt';
const SUDO_COOKIE_KEY = 'lunchr:sudo';
const IS_CONNECTED_COOKIE_KEY = 'lunchr-connected-on-app';
const OKARITO_COOKIE_KEY = 'auth._token.local';
const USER_COOKIE_EXPIRATION_TIME = 3600 * 24 * 3; // 3d
const isProd = config_1.isRealProd;
class Auth {
    constructor() {
        this.sudo = false;
        this.isLoggedIn = () => {
            if (!this.jwt) {
                return false;
            }
            try {
                const { exp: expirationTimestamp } = (0, jwt_decode_1.default)(this.jwt);
                return expirationTimestamp ? expirationTimestamp * 1000 > Date.now() : false;
            }
            catch (error) {
                console.error('Error parsing JWT token', error);
                return false;
            }
        };
        /**
         * Sets the user to the local storage
         */
        this.setUser = (user) => {
            this.user = user;
            user_storage_1.default.set(user);
            if (config_1.isRealProd) {
                cookies.set(IS_CONNECTED_COOKIE_KEY, true, {
                    path: '/',
                    maxAge: USER_COOKIE_EXPIRATION_TIME,
                    secure: isProd,
                    domain: this.cookieRootDomain,
                });
            }
        };
        this.getUser = () => {
            return user_storage_1.default.get();
        };
        this.setJwt = (jwt, rt = undefined) => {
            this.jwt = jwt;
            this.rt = rt;
            cookies.set(JWT_COOKIE_KEY, jwt, this.tokensCookieOptions);
            if (this.rt) {
                cookies.set(REFRESHTOKEN_COOKIE_KEY, rt, this.tokensCookieOptions);
            }
        };
        this.setSudo = (sudo) => {
            this.sudo = sudo;
            cookies.set(SUDO_COOKIE_KEY, sudo, this.tokensCookieOptions);
        };
        this.tokensCookieOptions = {
            path: '/',
            maxAge: USER_COOKIE_EXPIRATION_TIME,
            secure: isProd,
            domain: config_1.COOKIE_DOMAIN,
            sameSite: 'lax',
        };
        this.isSudo = () => this.sudo;
        this.exchangeToken = async (payload) => {
            const res = await (0, exports.oauthFetch)(payload);
            const { access_token, refresh_token } = await (0, request_1.getResponse)(res);
            this.setJwt(access_token, refresh_token);
        };
        /**
         * Remove all cookie from a domain
         */
        this.removeAllDomainCookies = (domain) => {
            cookies.remove(JWT_COOKIE_KEY, {
                path: '/',
                domain,
            });
            cookies.remove(REFRESHTOKEN_COOKIE_KEY, {
                path: '/',
                domain,
            });
            cookies.remove(SUDO_COOKIE_KEY, {
                path: '/',
                domain,
            });
            cookies.remove(OKARITO_COOKIE_KEY, {
                path: '/',
                domain,
            });
        };
        this.logout = () => {
            this.user = null;
            this.jwt = undefined;
            this.rt = undefined;
            user_storage_1.default.remove();
            this.removeAllDomainCookies(config_1.COOKIE_DOMAIN);
            // Remove the root domain cookies
            this.removeAllDomainCookies(this.cookieRootDomain);
            if (config_1.isRealProd) {
                cookies.remove(IS_CONNECTED_COOKIE_KEY, {
                    path: '/',
                    domain: this.cookieRootDomain,
                });
            }
        };
        this.user = user_storage_1.default.get();
        this.readCookies();
    }
    readCookies() {
        this.jwt = cookies.get(JWT_COOKIE_KEY);
        this.rt = cookies.get(REFRESHTOKEN_COOKIE_KEY);
        this.sudo = cookies.get(SUDO_COOKIE_KEY) === 'true';
    }
    get token() {
        return this.jwt;
    }
    get cookieRootDomain() {
        return config_1.COOKIE_DOMAIN ? `.${config_1.COOKIE_DOMAIN.split('.').slice(-2).join('.')}` : undefined;
    }
}
// biome-ignore lint/style/noDefaultExport: not changing this
exports.default = new Auth();
//# sourceMappingURL=index.js.map